import { actionTypes } from "../../actions/action_types";

const initialState = {
  average_summary_collection: [],
  active_summary_collection: [],
  expired_summary_collection: [],
};

export default function sales_reducer(state = initialState, action) {
  var stateCopy = Object.assign({}, state);

  switch (action.type) {
    case actionTypes.REPORTS_SALES_GET_OVERALL_AVERAGE:
      stateCopy.average_summary_collection = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_SALES_GET_CLUSTER_AVERAGE:
      stateCopy.average_summary_collection = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_SALES_GET_AREA_AVERAGE:
      stateCopy.average_summary_collection = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_SALES_GET_BRANCH_AVERAGE:
      stateCopy.average_summary_collection = action.payload;
      return stateCopy;

    //---------

    case actionTypes.REPORTS_SALES_GET_OVERALL_ACTIVE:
      stateCopy.active_summary_collection = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_SALES_GET_CLUSTER_ACTIVE:
      stateCopy.active_summary_collection = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_SALES_GET_AREA_ACTIVE:
      stateCopy.active_summary_collection = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_SALES_GET_BRANCH_ACTIVE:
      stateCopy.active_summary_collection = action.payload;
      return stateCopy;
    //-------

    case actionTypes.REPORTS_SALES_GET_OVERALL_EXPIRED:
      stateCopy.expired_summary_collection = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_SALES_GET_CLUSTER_EXPIRED:
      stateCopy.expired_summary_collection = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_SALES_GET_AREA_EXPIRED:
      stateCopy.expired_summary_collection = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_SALES_GET_BRANCH_EXPIRED:
      stateCopy.expired_summary_collection = action.payload;
      return stateCopy;

    default:
      return state;
  }
}
